import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Container, FormHelperText } from '@material-ui/core';
import 'moment/locale/es';
import MomentUtils from '@date-io/moment';
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import { useDatePickersStyles } from './styles';

const DatePickers = ({ ...props }) => {
  const {
    issueFormName,
    disabled,
    name,
    error,
    value,
    label,
    required,
    onChange,
    errorMessage,
    disableFuture,
    disablePast,
    helperText,
    maxDate,
    minDate,
    shouldDisableDate,
  } = props;

  const classes = useDatePickersStyles();

  const formatDateWithoutTime = (date) => {
    return date ? moment(date).format('YYYY-MM-DD') : '';
  };

  const handleChange = (event) => {
    let cleanDate = formatDateWithoutTime(event);
    onChange(cleanDate);
  };

  return (
    <MuiPickersUtilsProvider utils={MomentUtils}>
      <Container>
        <DatePicker
          className={classes.input}
          data-cy={
            issueFormName ? `input${name}${issueFormName}` : `input${name}`
          }
          disabled={disabled}
          name={name}
          label={label}
          required={required}
          error={error}
          value={value || null}
          disableFuture={disableFuture}
          disablePast={disablePast}
          maxDate={maxDate}
          minDate={minDate}
          shouldDisableDate={shouldDisableDate}
          disableToolbar
          autoOk
          invalidDateMessage="Fecha invalida"
          size="small"
          variant="inline"
          inputVariant="outlined"
          format="YYYY-MM-DD"
          onChange={handleChange}
        />
        {helperText && (
          <FormHelperText className={classes.helperText}>
            {helperText}
          </FormHelperText>
        )}
        {error && (
          <FormHelperText className={classes.errorText}>
            {errorMessage}
          </FormHelperText>
        )}
      </Container>
    </MuiPickersUtilsProvider>
  );
};

DatePickers.propTypes = {
  issueFormName: PropTypes.string,
  disabled: PropTypes.bool,
  name: PropTypes.string,
  error: PropTypes.bool,
  value: PropTypes.string,
  label: PropTypes.string,
  required: PropTypes.bool,
  errorMessage: PropTypes.string,
  onChange: PropTypes.func,
  disableFuture: PropTypes.bool,
  disablePast: PropTypes.bool,
  helperText: PropTypes.string,
  maxDate: PropTypes.func,
  minDate: PropTypes.func,
  shouldDisableDate: PropTypes.func,
};

export default DatePickers;
